import { Fragment } from 'react';
import { calmTokens as t } from '../../shared/tokens';
import { dayOfWeekShort, fmtDateLong, fmtEUR } from '../../shared/format';
import CalmTxCard from './CalmTxCard';

export default function CalmDayGroup({ dateIso, txs, onToggle, onEdit, onDelete }) {
  const dayLabel = fmtDateLong(dateIso);
  const dayAbbr = dayOfWeekShort(dateIso);
  const total = txs.reduce(
    (s, tx) => s + (tx.type === 'credit' ? tx.amount : -tx.amount),
    0
  );
  const positive = total >= 0;

  return (
    <div style={{ marginBottom: 'var(--day-group-mb)' }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: 'var(--day-head-pad)',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'baseline', gap: 10 }}>
          <span
            style={{
              fontSize: 13,
              fontWeight: 600,
              color: t.text,
              letterSpacing: -0.1,
              textTransform: 'capitalize',
              fontFamily: t.fontUi,
            }}
          >
            {dayLabel}
          </span>
          <span
            style={{
              fontSize: 12,
              color: t.textMute,
              fontFamily: t.fontUi,
            }}
          >
            {dayAbbr}
          </span>
        </div>
        <div
          style={{
            fontFamily: t.fontMono,
            fontSize: 12,
            color: positive ? t.credit : t.debit,
            opacity: 0.75,
            fontVariantNumeric: 'tabular-nums',
          }}
        >
          {positive ? '+ ' : '− '}
          {fmtEUR(Math.abs(total))}
        </div>
      </div>

      <div
        style={{
          background: t.surface,
          border: `1px solid ${t.border}`,
          borderRadius: 16,
          overflow: 'hidden',
        }}
      >
        {txs.map((tx, i) => (
          <Fragment key={tx._id || tx.id || `${dateIso}-${i}`}>
            {i > 0 && (
              <div
                style={{
                  height: 1,
                  background: t.border,
                  margin: '0 20px',
                }}
              />
            )}
            <CalmTxCard
              tx={tx}
              onToggle={onToggle}
              onEdit={onEdit}
              onDelete={onDelete}
            />
          </Fragment>
        ))}
      </div>
    </div>
  );
}
